enum CanineMolar {
  'CANINE' = 'CANINE',
  'CANINE_MOLAR' = 'CANINE_MOLAR',
}

export { CanineMolar }
